import Api from "@/services/Index";

const facultyComparisonReport = async (config) => {
    return Api.get("/promotional/processes/reports/faculty-comparison-report", config);
};
const getCandidateFirstChoiceSurveyCountReport = async (config) => {
    return Api.get("/promotional/processes/reports/candidate-first-choice-survey-count-report", config);
};
const getCandidateSurveyCountReport = async (config) => {
    return Api.get("/promotional/processes/reports/candidate-survey-count-report", config);
};

export default {
    facultyComparisonReport,
    getCandidateFirstChoiceSurveyCountReport,
    getCandidateSurveyCountReport,
};
